import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {Global} from "../../global";

@Component({
  selector: 'app-pdf-ficha-cliente',
  templateUrl: './pdf-ficha-cliente.component.html'
})
export class PdfFichaClienteComponent {

  url = '';

  constructor(
    public global: Global,
    private route: ActivatedRoute
  ) {
    route.params.subscribe(params => {
      this.url = global.dominio_site+'/cli/clientes-usuarios/minhas-fichas/'+params['id_ficha']+'/pdf/?tk='+localStorage.getItem('token');
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/area-cliente/minhas-fichas/pdf-ficha-cliente.component.ts